import { IAppState } from '../../redux';

export function selectMaximalBet(state: IAppState): number {
  const {
    auction: { maximalBet },
  } = state;

  return maximalBet;
}
